import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
/* eslint-disable prefer-spread */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

/**
 * @description This function should never change except if we have big change of way we get segment snippet
 */
export const initSegmentSnippet = apiKey => {
  const globalAnalyticsKey = 'analytics';

  // Prevent this code from running serverside
  if (typeof window === 'undefined') return;
  const analytics = window[globalAnalyticsKey] = window[globalAnalyticsKey] || [];
  if (analytics.initialize) return;

  // If the snippet was invoked already show an error.
  if (analytics.invoked) {
    return;
  }
  analytics.invoked = true;
  analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'screen', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware', 'register'];
  analytics.factory = function (e) {
    return /*#__PURE__*/_asyncToGenerator(function* () {
      if (window[globalAnalyticsKey].initialized) {
        return window[globalAnalyticsKey][e].apply(window[globalAnalyticsKey], arguments);
      }
      const args = Array.prototype.slice.call(arguments);
      if (['track', 'screen', 'alias', 'group', 'page', 'identify'].indexOf(e) > -1) {
        const c = document.querySelector("link[rel='canonical']");
        args.push({
          __t: 'bpc',
          c: c && c.getAttribute('href') || undefined,
          p: location.pathname,
          u: location.href,
          s: location.search,
          t: document.title,
          r: document.referrer
        });
      }
      args.unshift(e);
      analytics.push(args);
      return analytics;
    });
  };
  for (let i = 0; i < analytics.methods.length; i++) {
    const key = analytics.methods[i];
    analytics[key] = analytics.factory(key);
  }
  analytics.load = function (key, i) {
    const t = document.createElement('script');
    t.type = 'text/javascript';
    t.async = true;
    t.setAttribute('data-global-segment-analytics-key', globalAnalyticsKey);
    t.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
    const n = document.getElementsByTagName('script')[0];
    n.parentNode.insertBefore(t, n);
    analytics._loadOptions = i;
  };
  analytics._writeKey = apiKey;
  analytics.SNIPPET_VERSION = '5.2.1';
};
//# sourceMappingURL=segment.js.map